import {useContext} from 'react';
import {FiltersContext} from '../contexts/FiltersContext';

export const useFilter = name => {
  const {filters, setFilters} = useContext(FiltersContext);
  const filterValue = filters[name] || [];

  const setFilter = newValue => {
    if (!Array.isArray(newValue)) {
      throw new Error(
        "Filters:: You must pass an array to useFilter's setter function.",
      );
    }

    setFilters({
      ...filters,
      [name]: newValue,
    });
  };

  return [filterValue, setFilter];
};

export const useFilters = () => {
  return useContext(FiltersContext);
};
